import type { BoxId, NodeRecord } from '../nodes';
import type { EdgeData } from './EdgeData';

export const getEdgeBoxId = (
  edge: EdgeData,
  nodes: NodeRecord,
): BoxId | null => {
  const sourceNodeData = nodes[edge.source];
  const targetNodeData = nodes[edge.target];

  return sourceNodeData !== undefined &&
    sourceNodeData.boxId !== null &&
    sourceNodeData.boxId === targetNodeData?.boxId
    ? sourceNodeData.boxId
    : null;
};
